<template>
  <div>
    <div v-if="profile">
      <div class="row mb-3">
        <div class="col s12">
          <label for="pageName">{{ $t('Page name') }}</label>
        </div>
        <div class="col s12">
          <h3>{{ profile.pagename }}</h3>
        </div>
      </div>

      <div class="row" v-if="selectedBot.theme == 'ecommercebasic'">
        <!-- <div class="col s12">
          <label for="pageShortLink">{{ $t('Page short link') }}</label>
        </div> -->

        <div
          class="col s12 form-control"
          :class="{ 'has-error': errors.has('pageShortLinkInput') }"
        >
          <div class="mb-2" style="overflow: auto">
            <label> {{ $t('Page link (required login)') }} : </label>
            <a
              class="blue--text text--darken-2"
              target="BLANK"
              :href="
                `https://shopv2.zwiz.app/ecommerce/${pageid}?lang=${profile.shoplang.value ||
                  currentLang}`
              "
              id="eLink"
            >
              {{
                `https://shopv2.zwiz.app/ecommerce/${
                  profile.pageshortlink ? profile.pageshortlink : pageid
                }?lang=${profile.shoplang.value || currentLang}`
              }}
            </a>
            <v-tooltip v-model="showCopyEcommerce" bottom color="success">
              <template v-slot:activator="{}">
                <v-icon
                  class="mr-2"
                  size="16px"
                  style="cursor: pointer"
                  @click="copyEcommerceLink()"
                >
                  content_copy
                </v-icon>
              </template>
              <span>{{ $t('Copied') }}</span>
            </v-tooltip>
            <span>
              <a href="https://blog.zwiz.app/link-shopservice-2/" target="_blank" ref="noopener noreferrer">
                [{{ $t('Read how to use the link') }}]
              </a>
            </span>
          </div>
        </div>
        <div
          class="col s12 form-control"
          :class="{ 'has-error': errors.has('pageShortLinkInput') }"
        >
          <div class="mb-2" style="overflow: auto">
            <label> {{ $t('Salepage link (no login required)') }} : </label>
            <a
              class="blue--text text--darken-2"
              target="BLANK"
              :href="
                `https://shopv2.zwiz.app/salepage/${pageid}?lang=${profile.shoplang.value ||
                  currentLang}`
              "
              id="sLink"
            >
              <template>
                {{
                  `https://shopv2.zwiz.app/salepage/${
                    profile.pageshortlink ? profile.pageshortlink : pageid
                  }?lang=${profile.shoplang.value || currentLang}`
                }}
              </template>
            </a>
            <v-tooltip v-model="showCopySalePage" bottom color="success">
              <template v-slot:activator="{}">
                <v-icon
                  class="mr-2"
                  size="16px"
                  style="cursor: pointer"
                  @click="copySalePageLink()"
                >
                  content_copy
                </v-icon>
              </template>
              <span>{{ $t('Copied') }}</span>
            </v-tooltip>
            <span>
              <a href="https://blog.zwiz.app/link-salepage/" target="_blank" ref="noopener noreferrer">
                [{{ $t('Read how to use the link') }}]
              </a>
            </span>
          </div>
        </div>
        <div
          class="col s12 mb-4 form-control"
          :class="{ 'has-error': errors.has('pageShortLinkInput') }"
        >
          <div class="mb-2" style="overflow: auto">
            <label> {{ $t('Link in chatbot button') }} : </label>
            <span>
              <a href="https://blog.zwiz.app/goto-shopservice/" target="_blank" ref="noopener noreferrer">
                [{{ $t('Read how to create link') }}]
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col s12">
          <label>
            {{ $t('Shop Color') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <template v-if="isEdit && $store.getters.getPackage == 'premium'">
            <swatches
              v-model="profile.shopcolor"
              show-fallback
              fallback-input-type="color"
            ></swatches>
          </template>
          <template v-else>
            <div
              style="width: 50px; height: 50px; border-radius: 10px"
              :style="{ background: profile.shopcolor }"
            ></div>
          </template>
        </div>
      </div>
      <div class="row">
        <div class="col s12">
          <div>
            <label>
              {{ $t('Shop Language') }}
              <v-premium-lock :inline="true"></v-premium-lock>
            </label>
          </div>
          <div class="mb-2">
            <template v-if="isEdit && $store.getters.getPackage == 'premium'">
              <multiselect
                v-model="profile.shoplang"
                :options="langOptions"
                label="label"
                :allow-empty="false"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
                track-by="label"
                @select="onSelectLang"
              ></multiselect>
            </template>
            <div v-else class="primary-color">{{ profile.shoplang.label }}</div>
          </div>
        </div>
      </div>

      <div
        class="row mb-3"
        v-if="showAddress && ['ecommercebasic', 'adminperform'].includes(selectedBot.theme)"
      >
        <div class="col s12">
          <label for="pageAddress">{{ $t('Shop address') }}</label>
          <v-btn
            v-if="isEdit"
            @click="routedPush"
            fab
            outline
            small
            color="primary"
            style="width: 30px; height: 30px;"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
        <div class="col s12 form-control">
          <div class="primary-color">{{ shopProfile ? shopProfile : '-' }}</div>
        </div>
      </div>
    </div>
    <div v-else-if="loadingGetShopProfile" class="text-xs-center" style="min-height: 400px">
      <v-layout justify-center align-center row style="height: 400px">
        <v-flex>
          <div class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="row text-xs-center mb-2">
      <div class="col s12">
        <template v-if="isEdit">
          <v-btn @click="cancelEdit" outline color="grey">{{ $t('cancel') }}</v-btn>
          <v-btn
            @click="saveContent"
            :loading="loading"
            :disabled="loading"
            depressed
            color="primary"
            >{{ $t('Save') }}</v-btn
          >
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import config from '@/config'
import api from '@/api'
import Tooltip from '@/components/elements/Tooltip'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'
import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  props: {
    isEdit: undefined,
    modalOpen: {
      type: Boolean,
      default: true
    },
    showAddress: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      profile: null,
      loading: false,
      loadingGetShopProfile: false,
      lang: {
        value: 'th',
        flag: 'th',
        label: 'Thai'
      },
      color: '#1CA085',
      oldProfile: null,
      langOptions: [
        {
          value: 'en',
          flag: 'gb',
          label: 'English'
        },
        {
          value: 'th',
          flag: 'th',
          label: 'Thai'
        },
        {
          value: 'la',
          flag: 'la',
          label: 'Laos'
        }
      ],
      showSaveShortlink: false,
      showSaveDescription: false,
      showSaveAddress: false,
      isChangeShortlink: false,
      isChangeDescription: false,
      isChangeAddress: false,
      toggleSetWeight: false,
      isCopiedEcommerce: false,
      isCopiedSalePage: false,
      showCopyEcommerce: false,
      showCopySalePage: false
    }
  },
  components: {
    Tooltip,
    Swatches,
    Multiselect,
    ToggleButton
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang'
    }),
    pageid: function() {
      if (!this.$store.state.selectedBot) {
        return null
      }
      return this.$store.state.selectedBot.pageid
    },
    shopProfile() {
      const vm = this
      try {
        const shopProfile = JSON.parse(vm.selectedBot.shopaddressarray).filter(
          item => item.selected
        )
        return `${shopProfile[0].name || ''} ${shopProfile[0].addressno || ''} ${shopProfile[0]
          .sub_district || ''} ${shopProfile[0].district || ''} ${shopProfile[0].province ||
          ''} ${shopProfile[0].postcode || ''} ${vm.$t('Tel')}.${shopProfile[0].tel || ''}`
      } catch (error) {
        return '-'
      }
    }
  },
  mounted: function() {
    this.toggleSetWeight = this.selectedBot.is_display_transport_weight
    if (this.modalOpen) {
      this.getShopProfile()
    }
  },
  methods: {
    onChangeStatus() {
      this.toggleSetWeight = !this.toggleSetWeight
      this.putPageReceiptConfig(this.toggleSetWeight)
    },
    async putPageReceiptConfig() {
      this.$store.dispatch('loading')
      var data = {
        body: { is_display_transport_weight: this.toggleSetWeight },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
        this.$store.dispatch('updateBotDetail')
      } else {
        this.toggleSetWeight = !this.toggleSetWeight
      }
      this.$store.dispatch('loading')
    },
    setWeight() {
      const vm = this
      if (vm.toggleSetWeight != false) {
        return vm.$t('on_set_weight')
      } else {
        return vm.$t('off_set_weight')
      }
    },
    routedPush() {
      const vm = this
      localStorage.setItem('currentView', 'shipping-main')
      vm.$router.push('/' + vm.currentLang + `/template?tab=ShippingMethod`).catch(() => {})
    },
    onSelectLang: function(val) {
      this.lang = val
      this.profile.shoplang = val.value
    },
    getShopProfile: function() {
      let vm = this
      // vm.$store.dispatch('loading')
      if (!this.pageid || this.pageid == null) {
        return false
      }
      let data = {
        pageid: this.pageid
      }
      api.getShopProfile(data, function(error, response) {
        if (error) {
          console.error(error)
          // vm.$store.dispatch('loading')
          return
        }
        if (response.shopprofile) {
          var description
          try {
            if (response.shopprofile.description) {
              description = JSON.parse(response.shopprofile.description)
            } else {
              description = { phoneno: '', companyname: '' }
            }
          } catch (error) {
            description = { phoneno: '', companyname: '' }
          }
          var profile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shopcolor: response.shopprofile.shopcolor,
            shoplang: vm.langOptions.find(el => el.value == response.shopprofile.shoplang),
            phoneno: description.phoneno ? description.phoneno : '',
            companyname: description.companyname ? description.companyname : ''
          }
          vm.profile = { ...profile }
          vm.oldProfile = { ...profile }
          // vm.$store.dispatch('loading')
        }
        vm.loadingGetShopProfile = false
        vm.loading = false
      })
    },
    resetPageShortLink: function() {
      if (!this.pageid || this.pageid == null) {
        return false
      }
      this.isChangeShortlink = true
      this.profile.pageshortlink = this.pageid
    },
    cancelEdit: function() {
      this.profile = { ...this.oldProfile }
      this.$emit('onSave')
    },
    saveContent: function() {
      let vm = this
      vm.loading = true
      if (!vm.pageid || vm.pageid == null) {
        return false
      }
      let data = {
        description: vm.profile.description != null ? vm.profile.description : '',
        pageaddress: vm.profile.pageaddress != null ? vm.profile.pageaddress : '',
        pageid: vm.pageid,
        pageshortlink: vm.profile.pageshortlink != null ? vm.profile.pageshortlink : vm.pageid,
        shopcolor: vm.profile.shopcolor,
        shoplang: vm.profile.shoplang.value
      }
      data.description = JSON.stringify({
        companyname: vm.profile.companyname,
        phoneno: vm.profile.phoneno
      })

      vm.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        // if (vm.isChangeShortlink || vm.isChangeDescription || vm.isChangeAddress) {

        api.editShopProfile(data, function(error, response) {
          vm.loading = false
          if (error) {
            console.error(error)
            return
          }
          vm.$emit('onSave')
          vm.$store.state.pageProfile = data
          vm.oldProfile.description = vm.profile.description
          vm.oldProfile.pageaddress = vm.profile.pageaddress
          vm.oldProfile.pageshortlink = vm.profile.pageshortlink
          // switch (type) {
          //     case 'shortlink':
          //         vm.showSaveShortlink = true
          //         break;
          //     case 'description':
          //         vm.showSaveDescription = true
          //         break;
          //     case 'address':
          //         vm.showSaveAddress = true
          //         break;
          // }
          // vm.isChangeShortlink = false
          // vm.isChangeDescription = false
          // vm.isChangeAddress = false
        })
        // }
      })
    },
    copyEcommerceLink() {
      const copyLink = document.getElementById('eLink')
      const range = document.createRange()
      range.selectNode(copyLink)
      var selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      selection.removeAllRanges()

      this.showCopyEcommerce = true
      setTimeout(() => {
        this.showCopyEcommerce = false
      }, 3000)
    },
    copySalePageLink() {
      const copyLink = document.getElementById('sLink')
      const range = document.createRange()
      range.selectNode(copyLink)
      var selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      selection.removeAllRanges()

      this.showCopySalePage = true
      setTimeout(() => {
        this.showCopySalePage = false
      }, 3000)
    }
  },
  watch: {
    modalOpen: function(newVal, oldVal) {
      if (newVal) {
        this.loadingGetShopProfile = true
        this.loading = true
        this.getShopProfile()
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShopProfile.vue